import PinnedPrompts from "./PinnedPrompts";
import PinnedLists from "./PinnedLists";
import ProfilePinOwnerCallout from "./ProfilePinOwnerCallout";
import { ListSerializersListGroup, PageSerializersUsersShowPublic, PromptSerializersPrompt } from "types/serializers";

export interface Props {
  user: PageSerializersUsersShowPublic;
  lists: ListSerializersListGroup[];
  prompts: PromptSerializersPrompt[];
}
export default function ProfilePins({ user, lists, prompts }: Props) {

  if (lists.length === 0 && prompts.length === 0) {
    return <ProfilePinOwnerCallout user={user} />;
  }

  return (
    <>
      {prompts.length > 0 && <PinnedPrompts prompts={prompts} user={user} />}
      {lists.length > 0 && <PinnedLists lists={lists} user={user} />}
    </>
  );
}
